import { OnBeforeFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Controller } from '@philips-internal/oswald-ui-core/lib/client/controller';
import { FragmentNames, MealDeliveryPatientAliases } from '../../../codegen';

import InformationBarUtils from '../../commons/header/information-bar-header-utils';

import BaseController from '../../BaseController';
import { FetchAPI } from '@philips-internal/oswald-ui-components';
import { FetchEvent } from '@philips-internal/oswald-ui-core/lib/component/types/fetchable';

import '../meals-to-deliver-cards-controller.css';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../constants/routes';

@Controller({ component: MealDeliveryPatientAliases.LAYOUT_MEAL_DELIVERY_PATIENT, fragment: FragmentNames.MEAL_DELIVERY_PATIENT })
class MealDeliveryPatientController extends BaseController {

  @OnMount({ target: MealDeliveryPatientAliases.LAYOUT_MEAL_DELIVERY_PATIENT })
  handleMountLayout(): void {
    const {
      departmentCode,
      encounterId,
      patientId
    } = this.historyService.getCurrentRouteParams();

    InformationBarUtils.collapsedBar = true;

    this.context.set({
      departmentCode,
      encounterId,
      patientId,
    });
  }

  @OnBeforeFetch({ target: MealDeliveryPatientAliases.MEALS_FETCH })
  handleBeforeFetch(event: FetchEvent): void {
    const fetchApi = event.target as FetchAPI;
    const encounterId = this.context.get('encounterId') as string;
    fetchApi.setParameters({ encounterId });
  }

  @OnClick({ target: MealDeliveryPatientAliases.REGISTER_MEAL_DELIVERY_BUTTON })
  handleClick(): void {
    const departmentCode = this.context.get('departmentCode');
    const encounterId = this.context.get('encounterId');
    const patientId = this.context.get('patientId');
    applicationContext.redirect(ApplicationRoute.MEALS_TO_DELIVER, {departmentCode, encounterId, patientId});
  }
}

export default MealDeliveryPatientController;